import React from "react";
import { Col, Row } from "react-bootstrap";
import { Shield } from "react-bootstrap-icons";
import { useSelector } from "react-redux";

const EligibilityCoveragePersonal = () => {
  const { eligibilityCheckData } = useSelector(
    (state) => state.eligibilityCheck
  );

  const benefits = eligibilityCheckData?.benefits;

  // Get copayment info for medications
  const getMedicationCopayment = (categoryCode) => {
    const categoryItems =
      benefits?.filter((item) =>
        item?.category?.coding?.some((c) => c?.code === categoryCode)
      ) || [];

    for (const item of categoryItems) {
      const itemBenefits = item?.benefit || [];
      const copayPercentBenefit = itemBenefits.find((b) =>
        b?.type?.coding?.some((c) => c?.code === "copay-percent")
      );
      const copayMaxBenefit = itemBenefits.find((b) =>
        b?.type?.coding?.some((c) => c?.code === "copay-maximum")
      );

      if (copayPercentBenefit && copayMaxBenefit) {
        const copayPercent = copayPercentBenefit?.allowedUnsignedInt;
        const copayMax = copayMaxBenefit?.allowedMoney;

        let result = [];
        if (copayPercent !== undefined) result.push(`${copayPercent}%`);
        if (copayMax) result.push(`Max ${copayMax.value} ${copayMax.currency}`);
        return result.length > 0 ? result.join(" ") : null;
      }
    }

    return null;
  };

  const coveragePersonal = eligibilityCheckData?.coverage_info;

  // Define base coverage fields
  const baseFields = [
    { label: "Coverage Type", key: "coverage_type", default: "-" },
    { label: "Coverage Relationship", key: "relation", default: "-" },
    { label: "Coverage Class", key: "class" },
    { label: "Membership No", key: "memberid", default: "-" },
    { label: "Policy No", key: "policyno" },
    { label: "Policy Holder Name", key: "policyname" },
    { label: "Max Limit", key: "maxlimit" },
    { label: "Deductible Rate", key: "deductable" },
    { label: "Network", key: "network" },
    { label: "Sponsor Number", key: "sponsor_no", default: "" },
    { label: "Sponsor Name", key: "sponsor_name", default: "" },
  ];

  // Prepare base coverage data
  const coverageData = baseFields
    .map(({ label, key, default: def }) => {
      let value = coveragePersonal?.[key] || def;
      if (key === "maxlimit") value = `${value || 0} SAR`;
      if (key === "deductable") value = `${value || 0} %`;
      return { label, value };
    })
    .filter(({ value }) => value?.toString().trim() !== "");

  // Add medication copayments
  const benefitsMapping = [
    { code: "66", label: "Generic Medication" },
    { code: "57", label: "Brand Medication" },
    { code: "28", label: "Optical Medication" },
  ];

  benefitsMapping.forEach(({ code, label: mapLabel }) => {
    const copayment = getMedicationCopayment(code);
    if (copayment) {
      coverageData.push({
        label: `${mapLabel} Copayment`,
        value: <span className="text-danger">{copayment}</span>,
      });
    }
  });

  return (
    <div className="d-flex gap-2 flex-column">
      <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-warning w-50 p-3">
        <Shield className="fs-9" />
        <span className="fs-11">Coverage Information</span>
      </span>
      <div className="mt-3">
        {coverageData.map((item, index) => (
          <Row
            key={index}
            className="border-bottom border-dashed pb-2 mb-2 align-items-center"
          >
            <Col xs={5} className="text-700 fs-11 fw-bolder">
              {item.label}
            </Col>
            <Col xs={7} className="text-500 fs-11 fw-600">
              {item.value}
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
};

export default EligibilityCoveragePersonal;
